import React from "react";
import Grid from "@material-ui/core/Grid";
import { withStyles } from "@material-ui/core/styles";
import CardTeam from "./CardTeam";

const styles = theme => ({
  container: {
    marginTop: theme.spacing.unit
  }
});

class ListTeam extends React.PureComponent {
  render() {
    const { classes, teams } = this.props;

    if (!teams || Object.keys(teams).length === 0) return null;

    return (
      <Grid
        container
        className={classes.container}
        justify="flex-start"
        spacing={24}
      >
        {Object.keys(teams).map(teamId => (
          <CardTeam key={teamId} team={teams[teamId]} />
        ))}
      </Grid>
    );
  }
}

export default withStyles(styles)(ListTeam);
